export default __webpack_public_path__ + "static/media/ART5.70fbc833.jpg";